export const selectAcceptPriceChanges = (state) => state.acceptAllPriceChangesToggle || {};
